// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".groupActiveCode-container .el-link.el-link--default[data-v-1f46ebb8] {\n  margin: 0 5px;\n  color: \"#699eff\";\n}\n.groupActiveCode-container .operation-btn[data-v-1f46ebb8] {\n  margin-right: 10px;\n}\n.groupActiveCode-container .staff-pagination[data-v-1f46ebb8] {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  height: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
